import Settings from 'app/config/settings';
import Tenancy from 'app/lib/tenancy';

const client = Tenancy.getTenant();

export const HideFromTenants = ({ children, tenants = [], fallbackComponent = null }: any) => {
  if (tenants.length > 0) {
    return tenants.includes(client) ? fallbackComponent : children;
  }

  return Settings.Cobranded ? fallbackComponent : children;
};
